import React from 'react';
import PropTypes from 'prop-types';
import { WarningTriangle } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/form/section-error.css';

const SectionError = React.memo(({ errorMsg }) => (
  <div className="section-error-wrapper">
    <div className="section-error">
      <div className="warning-svg-wrapper">
        <div className="warning-svg">
          <WarningTriangle />
        </div>
      </div>
      <p className="error-message">
        { errorMsg ? errorMsg : 'You have fields that need your attention' }
      </p>
    </div>
  </div>
));

SectionError.propTypes = {
  errorMsg: PropTypes.string,
};
export {
  SectionError,
};
